/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.13 public/models/animated_spiderman_ps5.glb 
*/

import React, { useRef, useEffect } from "react";
import { useFrame } from "@react-three/fiber";
import { useGLTF, useAnimations } from "@react-three/drei";
import { useGameStore } from "./Store";

export function SpiderManPS5(props) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF(
    "models/animated_spiderman_ps5.glb"
  );
  const { characterState, setCharacterState } = useGameStore((state) => ({
    characterState: state.characterState,
    setCharacterState: state.setCharacterState,
  }));

  const { actions } = useAnimations(animations, group);

  const actionRef = useRef();

  useEffect(() => {
    if (actions[characterState]) {
      actionRef.current = actions[characterState];
      actionRef.current.reset().fadeIn(0.2).play();
    }
    return () => {
      if (actionRef.current) {
        actionRef.current.fadeOut(0.2);
      }
    };
  }, [characterState]);

  useFrame(() => {
    // console.log(group.current.position);
    if (group.current.position.y > 0.1) {
      console.log("Hello jumping");
      setCharacterState("Jump");
    } else if (group.current.position.y < 0) {
      console.log("Hello landing");
      setCharacterState("Land");
    }
  });

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group name="Armature" rotation={[Math.PI / 2, 0, 0]}>
          <primitive object={nodes.mixamorigHips} />
          <group name="Spider-Man">
            <skinnedMesh
              name="Spider-Man_Redmesh"
              geometry={nodes["Spider-Man_Redmesh"].geometry}
              material={materials.Red}
              skeleton={nodes["Spider-Man_Redmesh"].skeleton}
            />
            <skinnedMesh
              name="Spider-Man_Redmesh_1"
              geometry={nodes["Spider-Man_Redmesh_1"].geometry}
              material={materials.Blue}
              skeleton={nodes["Spider-Man_Redmesh_1"].skeleton}
            />
            <skinnedMesh
              name="Spider-Man_Redmesh_2"
              geometry={nodes["Spider-Man_Redmesh_2"].geometry}
              material={materials.Black}
              skeleton={nodes["Spider-Man_Redmesh_2"].skeleton}
            />
            <skinnedMesh
              name="Spider-Man_Redmesh_3"
              geometry={nodes["Spider-Man_Redmesh_3"].geometry}
              material={materials.White}
              skeleton={nodes["Spider-Man_Redmesh_3"].skeleton}
            />
          </group>
        </group>
      </group>
    </group>
  );
}

export default SpiderManPS5;

useGLTF.preload("models/animated_spiderman_ps5.glb");
